import axios from 'axios';

import { COOKIES } from '@config';

import { readCookie } from './cookie';

export const getRequestHeaders = () => {
  const headers: { [key: string]: string } = {
    Accept: 'application/json; charset=UTF-8',
  };

  const authToken = readCookie(COOKIES.AUTH_TOKEN, '');
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  const clientCSRFtoken = readCookie(COOKIES.CSRF_TOKEN, '');
  if (clientCSRFtoken) {
    headers['X-CSRFToken'] = clientCSRFtoken;
  }

  return headers;
};

// Fetch an authed (Bearer) endpoint as a blob and trigger a browser download.
// Used for the streamed store exports (a plain <a download> can't send the
// Authorization header). Loads the response into memory — fine for a deliberate
// one-off export.
export const downloadAuthedFile = async (url: string, filename: string) => {
  const response = await axios.get(url, {
    baseURL: import.meta.env.VITE_API_URL,
    headers: getRequestHeaders(),
    responseType: 'blob',
  });
  const blobUrl = URL.createObjectURL(response.data as Blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(blobUrl);
};
